module.exports = __webpack_public_path__ + "static/img/3s-platform-img6.2b5b84a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3s-platform-img6.png
// module id = 6E3d
// module chunks = 0